export interface IProgramChildSearchQuery {
    vacSiteId?: string;
    name?: string;
    address?: string;
    classroom? : string;
    childCode?: string;
    created?: string;
};

export interface IProgramClassroomChildSearchQuery {
  vacSiteId?: string;
  programName?: string;
  programAddress?: string;
  classroom? : string; // Name or StateId
  childCode?: string;
};